import React from 'react';

export const SoccerBallIcon: React.FC<{ className?: string, isOwnGoal?: boolean }> = ({ className = "w-3 h-3", isOwnGoal = false }) => (
  <svg viewBox="0 0 24 24" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11" fill={isOwnGoal ? "#e11d48" : "black"} />
    <circle cx="12" cy="12" r="10" fill="white" />
    <path d="M12 8.5l-2.5 1.8.9 2.9h3.2l.9-2.9z" fill={isOwnGoal ? "#e11d48" : "black"} />
    <path d="M12 1.5c-1 0-1.9.2-2.7.5L12 6l2.7-4c-.8-.3-1.7-.5-2.7-.5z" fill={isOwnGoal ? "#e11d48" : "black"} />
    <path d="M21.5 9.3c-.5-1.5-1.4-2.8-2.5-3.8l-1.5 4.5 4 .5z" fill={isOwnGoal ? "#e11d48" : "black"} />
    <path d="M2.5 9.3c.5-1.5-1.4-2.8-2.5-3.8l-1.5 4.5-4 .5z" fill={isOwnGoal ? "#e11d48" : "black"} />
    <path d="M18.5 18.5c1.1-1 2-2.3 2.5-3.8l-4 .5-1.5 4.5c1 .2 2 .1 3-.7z" fill={isOwnGoal ? "#e11d48" : "black"} />
    <path d="M5.5 18.5c-1.1-1-2-2.3-2.5-3.8l4 .5 1.5 4.5c-1 .2-2 .1-3-.7z" fill={isOwnGoal ? "#e11d48" : "black"} />
    <path d="M12 22.5c1 0 1.9-.2 2.7-.5L12 18l-2.7 4c.8.3 1.7.5 2.7.5z" fill={isOwnGoal ? "#e11d48" : "black"} />
  </svg>
);

export const JerseyIcon: React.FC<{ number: string, color: string, textColor: string, borderColor: string }> = ({ number, color, textColor, borderColor }) => (
    <div className="relative w-12 h-12 md:w-14 md:h-14 flex items-center justify-center md:group-hover:scale-110 transition-transform duration-300">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
            <path d="M6 4L4 7V11H7V21H17V11H20V7L18 4H14C14 5 13 6 12 6C11 6 10 5 10 4H6Z" fill={color} stroke={borderColor} strokeWidth="1" />
        </svg>
        <span 
            className="absolute inset-0 flex items-center justify-center text-[12px] md:text-[15px] font-black pt-1 tabular-nums select-none"
            style={{ color: textColor }}
        >
            {number}
        </span>
    </div>
);